import { HttpContext, HttpContextToken, HttpRequest } from '@angular/common/http';

import { environment } from '../../../environments/environment';

const isAbsoluteUrl = (url: string) => /^(https?:)?\/\//i.test(url);
const isTranslationAssetRequest = (url: string) => url.startsWith('/i18n/');
const cloneHttpContext = (context: HttpContext) => {
  const clonedContext = new HttpContext();

  for (const token of context.keys()) {
    clonedContext.set(token, context.get(token));
  }

  return clonedContext;
};

export const SUPPRESS_UNMAPPED_API_ERROR_ALERT = new HttpContextToken<boolean>(() => false);

export const createSuppressedUnmappedApiErrorAlertContext = (context = new HttpContext()) =>
  cloneHttpContext(context).set(SUPPRESS_UNMAPPED_API_ERROR_ALERT, true);

export const withSuppressedUnmappedApiErrorAlert = <T>(request: HttpRequest<T>) =>
  request.clone({
    context: createSuppressedUnmappedApiErrorAlertContext(request.context),
  });

export const isApiRequest = (request: HttpRequest<unknown>) => {
  if (isTranslationAssetRequest(request.url)) {
    return false;
  }

  if (environment.apiUrl) {
    return request.url.startsWith(environment.apiUrl);
  }

  return !isAbsoluteUrl(request.url);
};
